export const getProductEditPath = (productId: string): string => {
  return `/goods/edit/${productId}`
}